import {fonts} from '../../../../theme/foundations/fonts'
import sizes from '../../../../theme/foundations/sizes'
import {pxToRem} from '../../../../utills/pxToRem'
import size from '../../../../utills/size'

export const containerStyles = {
    position: 'relative',
    h1: {
        fontWeight: 600
    }
}

export const noSliderContainerStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    marginTop: pxToRem(15),
    '.slide-item': {
        flex: '1 1 0',
        marginRight: pxToRem(20),

        [`@media (max-width: ${size.md})`]: {
            marginRight: pxToRem(10)
        },
        '&:last-child': {
            marginRight: 0
        }
    }
}

export const headingStyles = {
    color: 'black',
    fontFamily: fonts.primary,
    fontSize: pxToRem(30),
    fontWeight: 700,
    letterSpacing: '4px',
    textTransform: 'uppercase',
    marginBottom: pxToRem(6),

    [`@media (max-width: ${size.md})`]: {
        fontSize: pxToRem(22),
        letterSpacing: pxToRem(3)
    }
}

export const topCategoriesStyle = {
    marginBottom: pxToRem(50),
    '.slick-list': {
        paddingTop: `${pxToRem(16)}`
    },
    '.slick-slide': {
        paddingRight: pxToRem(10),
        opacity: '0.6',
        transition: 'opacity 0.5s ease',
        [`@media (min-width: ${sizes.container.md})`]: {
            padding: `0 ${pxToRem(10)}`
        },
        '&.slick-active': {
            opacity: 1
        }
    },
    '.slick-track': {
        overflow: 'visible'
    },
    '.slide-item': {
        transition: 'transform 0.5s ease',
        img: {
            width: '100%',
            aspectRatio: 'auto 433 / 315'
        },
        '.product-category-title': {
            color: 'black',
            textAlign: 'center',
            fontFamily: fonts.primary,
            fontSize: pxToRem(14),
            fontWeight: 500,
            letterSpacing: '2px',
            textTransform: 'uppercase',
            marginTop: pxToRem(20),
            [`@media (max-width: ${size.md})`]: {
                marginTop: pxToRem(10),
                fontSize: pxToRem(12),
                letterSpacing: pxToRem(1)
            },
            '&:hover': {
                color: 'cav_red'
            }
        }
    },
    '.slick-arrow': {
        position: 'absolute',
        top: '45%',
        width: pxToRem(44),
        height: pxToRem(44),
        background: 'cav_light_black_aqua',
        color: 'white',
        borderRadius: '50%',
        textAlign: 'center',
        zIndex: 2,
        [`@media (max-width: ${size.md})`]: {
            width: pxToRem(30),
            height: pxToRem(30)
        },
        '&:hover': {
            background: 'white',
            color: 'black'
        }
    },
    '.slick-next, .slick-prev': {
        right: pxToRem(24)
    },
    '.slick-prev': {
        left: pxToRem(24)
    },
    '.slick-next:before, .slick-prev:before': {
        fontSize: 0
    }
}

export const carouselFirstFrameStyle = (tileCount) => {
    const {'.slide-item': rowTile, ...row} = noSliderContainerStyles
    const staticRow = {...row, '.category-banner-tile': rowTile}
    const slider = (slidesToShow, slidePadding, firstSlideOffset) => ({
        display: 'flex',
        overflow: 'hidden',
        paddingTop: pxToRem(16),
        '.category-banner-tile': {
            flex: `0 0 calc(100% / ${slidesToShow})`,
            padding: slidePadding,
            '&:first-of-type': {marginLeft: firstSlideOffset}
        }
    })
    return {
        '.calloutAdditionalWrapper': {display: 'none'},
        '.category-banner-tile': topCategoriesStyle['.slide-item'],
        '[data-sid="category-header-carousel"]': {
            '@media (max-width: 767.98px)':
                tileCount > 1 ? slider(1.5, `0 ${pxToRem(10)} 0 0`, 0) : staticRow,
            [`@media (min-width: ${size.md})`]:
                tileCount > 3 ? slider(3.1, `0 ${pxToRem(10)}`, 'calc(-100% / 31)') : staticRow
        }
    }
}

export const brandContainerStyles = {
    width: '96%',
    content: '""',
    clear: 'both',
    display: 'table',
    margin: '0 auto',
    padding: 0,
    border: '1px solid #F0F0F0',
    mb: pxToRem(20),

    '.brand-logo-container': {
        mr: '10%',
        height: pxToRem(150),
        mt: pxToRem(100),
        float: 'left',
        width: '20%',

        [`@media (max-width: ${size.md})`]: {
            width: '90%',
            textAlign: 'center',
            margin: '0 auto !important',
            float: 'none',
            height: 'auto !important',
            pt: `${pxToRem(10)} !important`
        },

        '+.plp-top-heading': {
            width: '60%',
            margin: '0 auto',
            [`@media (max-width: ${size.md})`]: {
                width: '95%'
            },

            h1: {
                textAlign: 'center',
                padding: `${pxToRem(20)} 0`,

                [`@media (max-width: ${size.md})`]: {
                    padding: `${pxToRem(20)} 0 ${pxToRem(30)} ${pxToRem(5)} !important`
                }
            }
        },

        img: {
            padding: `0 ${pxToRem(10)}`,

            [`@media (max-width: ${size.md})`]: {
                margin: 'auto'
            }
        }
    },

    '.plp-top-header-content': {
        padding: `0 ${pxToRem(10)} ${pxToRem(30)} 0`,
        width: '60%',
        margin: '0 auto',

        [`@media (max-width: ${size.md})`]: {
            width: '90%'
        }
    }
}
